module.exports = __webpack_public_path__ + "static/media/ford.76f86a94.svg";